
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCamHmiIec as ObiCamHmiIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cam-hmi-iec.js';
 
 
 

 
 export const ObiCamHmiIec = createComponent({
   react: React,
   tagName: 'obi-cam-hmi-iec',
   elementClass: ObiCamHmiIecElement,
   events: {
     
   }
  });
 
 